import { render, staticRenderFns } from "./SuggestionsWidget.vue?vue&type=template&id=0c1f2ccb&scoped=true&"
import script from "./SuggestionsWidget.vue?vue&type=script&lang=js&"
export * from "./SuggestionsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f2ccb",
  null
  
)

export default component.exports